import { configURL } from './api_urs'

export function apiFetch(method, route, data, authorization) {
  let headers = {
    'Content-Type': 'application/json',
  }
  if (authorization) {
    headers['Authorization'] = 'Bearer ' + authorization
  }

  const requestOptions = {
    method,
    headers,
    body: !!data ? JSON.stringify(data) : null,
  }

  return fetch(configURL() + route, requestOptions).then((response) =>
    response.json().then((json) => {
      if (json.error) {
        return Promise.reject([json.error, response.status])
      }

      return json
    }),
  )
}
